/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

export const getFormValues = (form: HTMLFormElement) => {
  if (!form) return null;

  const formData = new FormData(form);

  const checkboxes = form.querySelectorAll(
    'input[type="checkbox"]'
    // eslint-disable-next-line no-undef
  ) as NodeListOf<HTMLInputElement>;
  checkboxes.forEach((checkbox: HTMLInputElement) => {
    if (!formData.has(checkbox.name)) {
      formData.set(checkbox.name, 'false');
    }
    if (checkbox.checked) {
      formData.set(checkbox.name, 'true');
    }
  });

  if (formData && typeof formData.entries === 'function') {
    const entries = formData.entries();
    if (entries && typeof entries[Symbol.iterator] === 'function') {
      return JSON.parse(JSON.stringify(Object.fromEntries(entries))) || {};
    }
  }

  return {};
};
